<template>
  <v-dialog
    v-model="dialog"
    persistent
    max-width="700px"
  >
    <template v-slot:activator="{ on }">
      <v-btn
        color="primary"
        fab
        title="Create Payment Channel"
        v-on="on"
      >
        <v-icon medium>
          mdi-plus-circle
        </v-icon>
      </v-btn>
    </template>

    <material-card
      :offset="10"
      :full-width="true"
      :loading="loading"
      color="primary"
      style="margin-bottom:0"
    >
      <template v-slot:header>
        <v-card-title>
          <div class="px-2">
            <h4 class="title font-weight-light">
              Payment Channel
            </h4>
            <p class="category font-weight-thin">
              Create Payment Channel
            </p>
          </div>
          <v-spacer />
          <v-btn  
            text
            icon 
            color="white"
            @click="dialog = false"
          >
            <v-icon>close</v-icon>
          </v-btn>
        </v-card-title>
      </template>
      <v-form
        v-if="dialog && !loading"
      >
        <v-container
          class="overflow"
          data-simplebar
        >
          <v-row>
            <v-col>
              <v-autocomplete
                v-model="company"
                v-validate="'required'"
                item-text="name"
                item-value="id"
                :items="companies"
                label="Company"
                :error-messages="errors.collect('company')"
                data-vv-name="company" 
              />
            </v-col>
          </v-row>
          <v-row>
            <v-col>
              <v-autocomplete
                v-model="paymentChannelType"
                v-validate="'required'"
                item-text="name"
                item-value="id"
                :items="paymentChannelTypes"
                label="Payment Channel Type"
                :error-messages="errors.collect('type')"
                data-vv-name="type"
                data-vv-as="Payment Channel Type"
              />
            </v-col>
          </v-row>
          <v-row>
            <v-col>
              <v-autocomplete
                v-model="bank"
                v-validate="'required'"
                item-text="name"
                item-value="id"
                :items="banks"
                label="Bank"
                :error-messages="errors.collect('bank')"
                data-vv-name="bank"
              />
            </v-col>
          </v-row>
          <v-row>
            <v-col>
              <!-- <v-autocomplete
                v-model="selectedBranches"
                item-text="branch_name"
                item-value="branch_uid"
                :items="branches"
                label="Branches using Current Payment Channel - (Optional)"
                multiple
                chips
              /> -->
              <v-data-table
                v-model="selectedBranches"
                dense
                :headers="headers"
                :items="branches"
                hide-default-footer
                fixed-header
                disable-pagination
                item-key="branch_uid"
                item-value="branch_uid"
                show-select
                sort-by="branch_name"
                class="elevation-1 mb-3"
                :search="search"
                height="335px"
              >
                <template v-slot:top>
                  <v-toolbar
                    flat
                  >
                    <v-row>
                      <v-col class="col">
                        <v-toolbar-title>
                          Select at least one Branch:
                        </v-toolbar-title>
                      </v-col>
                      <v-col class="col">
                        <v-text-field
                          v-model="search"
                          label="Search"
                          append-icon="search"
                        />
                      </v-col>
                    </v-row>
                  </v-toolbar>
                </template>
              </v-data-table>
            </v-col>
          </v-row>
          <v-row>
            <v-col>
              <v-text-field
                v-model="reference"
                v-validate="'required'"
                label="Reference"
                :error-messages="errors.collect('reference')"
                data-vv-name="reference"
              />
            </v-col>
          </v-row>
          <v-row>
            <v-col>
              <span>Active Payment Channel?</span>
              <v-radio-group
                v-model="isActive"
                row
              >
                <v-radio
                  label="Yes"
                  :value="1"
                />
                <v-radio
                  label="No"
                  :value="0"
                />
              </v-radio-group>
            </v-col>
          </v-row>
          <v-card-actions>
            <v-spacer />
            <v-btn
              :loading="progressing"
              color="success"
              @click="submitForm"
            >
              Create
            </v-btn>
          </v-card-actions>
        </v-container>
      </v-form>
    </material-card>
  </v-dialog>
</template>

<script>
  export default {
    inject: ['$validator'],
    data () {
      return {
        dialog: false,
        loading: false,
        progressing: false,
        isActive: 1,

        branches: [],
        companies: [],
        headers: [
          { text: 'Branch', value: 'branch_name', align: 'left' },
        ],
        paymentChannelTypes: [],
        banks: [],

        company: '',
        paymentChannelType: '',
        bank: '',
        selectedBranches: [],
        search: '',
        reference: '',
      }
    },
    watch: {
      dialog (value) {
        if (!value) {
          this.$resetData()
        } else {
          this.loadData() 
        }
      },
    },
    methods: {
      loadData () {
        this.loading = true
        Promise.all([
          this.$api.companies().list(),
          this.$api.banks().list(),
          this.$api.paymentChannelTypes().list(),
          this.$api.branches().list(),
        ])
          .then(([companies, banks, paymentChannelTypes, branches]) => {
            this.companies = companies.data
            this.banks = banks.data
            this.paymentChannelTypes = paymentChannelTypes.data
            this.branches = branches.data
            this.loading = false
          })
      },
      submitForm () {
        this.$validator.validateAll()
          .then(result => {
            if (!result) return

            this.progressing = true

            this.$api.paymentChannels().create(this.prepareFormData())
              .then((response) => {
                if (response.status === 201) {
                  this.$emit('created')
                  this.$snack({ color: 'success', message: 'Payment Channel Successfully created' })

                  this.dialog = false
                }
              }).catch(err => {
                this.$snack({ color: 'error', message: err.response.statusText })
              }).then(() => {
                this.progressing = false
              })
          })
      },
      prepareFormData () {
        const branches = []
        this.selectedBranches.map((selectedBranch) => {
          branches.push(selectedBranch.branch_uid)
        })
        return {
          company_id: this.company,
          type_id: this.paymentChannelType,
          bank_id: this.bank,
          reference: this.reference,
          is_active: this.isActive,
          branches: branches,
        }
      },
    },
  }
</script>
<style>
  .overflow {
    height: 60vh;
    overflow-x: hidden;
  }

  .simplebar-track.simplebar-vertical .simplebar-scrollbar:before {
    background-image: linear-gradient( grey , grey);
  }
</style>
